import { useDispatch } from 'react-redux';

import { FormikHelpers } from 'formik';
import { useAtomValue } from 'jotai';
import { toast } from 'sonner';
import { SettingsLayout } from 'wbs-components-lib';

import { Typography } from '@mui/material';

import { useCreateTicketMutation } from '@services';

import { AppDispatch, setTicket } from '@store';

import {
  TicketSettingsForm,
  TicketSettingsFormValues,
  TICKET_SETTINGS_FORM_INITIAL_VALUES,
} from './TicketSettingsForm';
import { TicketSettingsTable } from './TicketSettingsTable';

import { isUserServiceAtom } from 'v2/atoms/userAtom';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';

export const TicketSettingsPage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [createTicket, { isLoading: isTicketCreating }] = useCreateTicketMutation();

  const isUserService = useAtomValue(isUserServiceAtom);

  const handleCreateModalSetting = async (
    { date, ...values }: TicketSettingsFormValues,
    { resetForm }: FormikHelpers<TicketSettingsFormValues>
  ) => {
    const createdTicket = await createTicket({
      ...values,
      date: date.format(),
    }).unwrap();

    dispatch(setTicket(createdTicket));

    resetForm();

    toast.success('Ticket has been created successfully');
  };

  return (
    <PageLayout>
      <Typography margin="10px" fontSize="24px" fontWeight={600}>
        Ticket Settings
      </Typography>
      <SettingsLayout
        formCaption="Create Ticket"
        itemsListComponent={<TicketSettingsTable isUserService={isUserService} />}
        formComponent={
          <TicketSettingsForm
            isSubmitting={isTicketCreating}
            initialValues={TICKET_SETTINGS_FORM_INITIAL_VALUES}
            onSubmit={handleCreateModalSetting}
            isUserService={isUserService}
          />
        }
      />
    </PageLayout>
  );
};
